import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IDropdownListItem} from "../../../../../shared/components/dropdown-list/dropdown-list-item";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {ICustomer} from "../../ecommerce-customer.interface";

@Component({
    selector: 'db-customers-table-row',
    templateUrl: './customers-table-row.component.html',
    styleUrls: ['./customers-table-row.component.scss'],
    standalone: false
})
export class CustomersTableRowComponent implements OnInit {
  @Input() customer: ICustomer;
  @Output() removeItem: EventEmitter<number> = new EventEmitter<number>();
  dropdownOptions: Array<IDropdownListItem> = [{
    action: this.onRemoveItem.bind(this),
    label: TextUtils.getText('text_removeCustomer')
  }];

  constructor() {
  }

  ngOnInit() {
  }

  onRemoveItem() {
    this.removeItem.emit(this.customer.id);
  }
}
